var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"under-contruction"},[_c('v-icon',{staticClass:"icon",attrs:{"x-large":""}},[_vm._v(_vm._s(_vm.mdiHandPeace))]),_c('h3',[_vm._v("Im Sorry "+_vm._s(_vm.pageName)+" Page is Under Contruction")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }